exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\np {\n  margin: -5px;\n  margin-left: 22px;\n  color: #eae8e8;\n}\n\nbutton {\n  display: inline-block;\n  background-color: #262626;\n  color: #eae8e8;\n  border-radius: 30px;\n  border: none;\n  padding: 4px;\n  width: 30px;\n  height: 30px;\n}\n\n@media screen and (max-width: 580px) {\n  p {\n    font-size: 10px;\n    margin-left: 10px;\n  }\n\n  button  {\n    font-size: 10px;\n    width: 15px;\n    height: 15px;\n    padding-bottom: 15px;\n    margin: 0px;\n  }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/BREA/Desktop/drum-machine/src/app/change-kit/change-kit.component.css
// module id = ../../../../../src/app/change-kit/change-kit.component.css
// module chunks = main